<template>
    <v-touch @swiperight="swiperright" class="wrapper">
        <div class="commonTableStyles contract-list">
            <van-nav-bar
                title="合同信息"
                left-arrow
                @click-left="onClickLeft"
            >
            </van-nav-bar>
            <section>
                <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
                    <van-list
                        v-model="isUpLoading"
                        :finished="finished"
                        finished-text="没有更多了!"
                        @load="onLoad"
                    >
                        <ul class="list">
                            <li v-for="(item,index) in listData" :key="item.contract_number + index" :class="`item-${item.contract_type}`">
                                <div class="engineeringInfo" @click="openDetails(item)">
                                    <h4 class="engineeringInfo_header">
                                        <span class="state">{{ item.contract_type | contractType }}</span>
                                        <span class="headerName">合同编号：{{ item.contract_number }}</span>
                                    </h4>
                                    <div class="engineeringInfo_content">
                                        <p>
                                            <img src="@/assets/images/icons/icon_gy_3.png" alt="">
                                            <span>工程名称：{{ item.engineering_name }}</span>
                                        </p>
                                        <p>
                                            <img src="@/assets/images/icons/icon_gy_7.png" alt="">
                                            <span>签订日期：{{ item.signing_date }}</span>
                                        </p>
                                        <p>
                                            <img src="@/assets/images/icons/icon_gy_8.png" alt="">
                                            <span>客户名称：{{ item.client_name }} </span>
                                        </p>
                                        <p>
                                            <img src="@/assets/images/icons/icon_gy_8.png" alt="">
                                            <span>客户联系人：{{ item.client_contact_name }} ({{ item.client_contact_phone }})</span>
                                        </p>
                                        <p>
                                            <img src="@/assets/images/icons/icon_gy_3.png" alt="">
                                            <span>审批状态：{{ approval_status[item.approval_status] }}</span>
                                        </p>
                                    </div>
                                </div>
                            </li>
                        </ul>
                    </van-list>
                </van-pull-refresh>
            </section>
        </div>
    </v-touch>
</template>

<script>
export default {
    // 客户查询关联 合同信息
    name: 'contract-list',
    beforeRouteLeave(to, from, next) {
        if (to.path === this.backUrl) {
            this.$store.commit('noKeepAlive', 'contract-list');
        }
        next();
    },
    data() {
        return {
            // 下拉login状态
            isLoading: false,
            // 上拉login状态
            isUpLoading: false,
            // 是否加载完数据
            finished: false,
            // 分页
            pageindex: 0,
            pagesize: 6,
            // 列表数据
            listData: [],
            // 列表总条数
            total: 0,
            // 是否是领导端
            isLeader: false,
            client_id: '',
            approval_status: {
                0: '未启动',
                1: '审批中',
                2: '审批通过',
                3: '审批未通过',
            },
            backUrl: '/customerManagement',
        };
    },
    filters: {
        contractType(type) {
            const arr = {
                '102-LS1': '临时',
                '102-LS2': '零售',
                '102-XX0': '现销',
                '102-ZS0': '正式',
            };
            return arr[type];
        },
    },
    computed: {},
    watch: {},
    created() {
        // 是否是领导端
        this.client_id = this.$route.query.client_id;
        if (this.$route.query.backUrl) {
            this.backUrl = this.$route.query.backUrl;
        }
    },
    methods: {
        // 拉取客户列表数据
        getList() {
            // 请求列表数据地址
            const getUrl = '/interfaceApi/sale/client_manager/get_contract_by_client_id'
                + `?client_id=${this.client_id}&pageindex=${this.pageindex}&pageSize=${this.pagesize}`;
            this.$axios
                .get(getUrl)
                .then(res => {
                    const data = res.rows || [];
                    if (data.length < this.pagesize) {
                        this.finished = true;
                    }
                    this.listData.push(...data);
                    this.isUpLoading = false;
                }).catch(error => {
                    this.finished = true;
                    this.isUpLoading = false;
                    this.$dialog({ message: error });
                });
        },
        // 返回上一页
        onClickLeft() {
            this.$router.isBack = 1;
            this.$router.push({ path: this.backUrl });
        },
        // 筛选条件-取消
        onClickRight() {
            this.popupShow = false;
            this.handleReset();
        },
        // 右划回退
        swiperright() {
            this.$router.isBack = 1;
            this.$router.push({ path: this.backUrl });
        },
        // 下拉刷新
        onRefresh() {
            this.pageindex = 0;
            this.listData = [];
            // 清空列表数据
            this.finished = false;
            // 重新加载数据
            this.isUpLoading = true;
            this.isLoading = false;
            this.onLoad();
        },
        // 上拉加载更多
        onLoad() {
            this.pageindex++;
            this.getList();
        },
        // 打开合同详情
        openDetails(item) {
            this.$router.isBack = 2;
            this.$router.push({ name: 'contractDetails', params: { obj: item, backUrl: '/contractList' } });
        },
    },
};
</script>
<style lang="stylus">
    .contrlMsgDialog
        .van-dialog__content
            text-align left!important
            padding 0!important
        ul
            li
                .con
                    padding 15rpx
                    h4
                        display flex
                        justify-content space-between
                        >span
                            &:first-child
                                font-size 16rpx
                                color #E60000
                            &:last-child
                                font-size 12rpx
                                color #666666
                    p
                        font-size 14rpx!important
                        margin-top 10rpx!important
                .split
                    height 15rpx
                    background #F0F0F0

    .contract-list
        height 100%
        .van-nav-bar
            display flex
            .iconshaixuan1
                font-size 20rpx
                color #ffffff
                margin-right 10rpx
            .van-nav-bar__content
                width 100%
            .van-nav-bar__right
                right 15rpx!important
                top 0
            .van-nav-bar__title
                max-width 100%
                .van-tabs
                    .van-tabs__nav
                        background rgba(0,0,0,0)
                    .van-tab
                        flex-basis auto !important
                        font-size 14rpx
                        margin 0 6rpx
                        line-height 44rpx
                        color rgba(240,240,240,0.5)
                        transition 0.2s
                        &.van-tab--active
                            font-size 16rpx
                            line-height 44rpx
                            color #FFFFFF
                        .van-tab__text
                            white-space nowrap
                    .van-ellipsis
                        text-overflow initial
                    .van-tabs__line
                        display none
                    .van-tabs__wrap
                        &:after
                            display none
            .van-ellipsis
                white-space normal
        // .van-nav-bar__right
        //     width 0
        section
            height calc(100% - 45rpx)
            .van-pull-refresh
                height 100%
                overflow: scroll;
                -webkit-overflow-scrolling: touch;
                .list
                    height calc(100% - 45rpx)
                    overflow-y auto
                    li
                        &:first-child
                            margin-top 15rpx
                        strong
                            color #d60110
                            position absolute
                            top 46rpx
                            right 15rpx
                        .engineeringInfo
                            .telephone
                                width 25rpx
                                height 25rpx
                                background url(./../../../assets/images/clueManagement/phone@2x.png)
                                background-size 100% 100%
                                border none
                                position absolute
                                right 15rpx
                                top 165rpx
                        .btns-con
                            display flex
                            >div
                                flex 1
                                text-align center
                                position relative
                                &:after
                                    content ' '
                                    position absolute
                                    top 5rpx
                                    right 0
                                    width 1px
                                    height 15rpx
                                    background #D7D7D7
                                .btn
                                    padding 4rpx 10rpx
                                    width 75rpx
                                    font-size 12rpx
                                    color #5588F1
                                    border-radius 4rpx
                                    border 1px solid #5588F1
                                    float none
                                    display inline-block
                                    box-sizing border-box
                                    >i
                                        float none
                                .star-btn
                                    border 1px solid #999999
                                    color #666666
                                    .iconfont
                                        font-size 12rpx
                                        margin-right 3rpx
                                .stared-btn
                                    border 1px solid #FF6600
                                    color #FF6600
                                    .iconfont
                                        font-size 12rpx
                                        margin-right 3rpx
                                &:last-child
                                    position relative
                                    &:after
                                        content ' '
                                        display none
                        .btns
                            padding 0 6rpx
                            text-align center
                            div
                                border 1px solid #D7D7D7
                                border-radius 4rpx
                                background #fff
                                height 32rpx
                                line-height 32rpx
                                text-align center
                                display inline-block
                                margin 0 25rpx
                                font-size 14rpx
                                color #333333
                                width calc((100% - 36rpx)/3)
                                img
                                    width 16rpx
                                    vertical-align middle
                                    margin-top -4rpx
        .contactInfo
            h5,p
                font-size 16rpx
                line-height 45rpx
                text-align center
            h5
                color #333333
                background #F8F8F8
            p
                color #0189FC
                border-bottom 1px solid  #F0F0F0
                a
                    color #0189fc
        .van-dialog
            .van-dialog__content
                padding 15rpx
                text-align center
                img
                    width 40rpx
                    height 40rpx
                p
                    font-size 14rpx
                    color #333333
                    margin-top 15rpx
        .screen
            height 100%
            section
                height calc(100% - 85rpx)
                overflow scroll
                -webkit-overflow-scrolling touch
                dd
                    margin-top 8rpx
                    display flex
                    flex-wrap wrap
                    .van-field
                        border 1px solid #ddd
                        padding 6rpx 10rpx
                    >span
                        width calc(33.33% - 10rpx)
                        background #F1F1F1
                        border 1px solid #F1F1F1
                        border-radius 6rpx
                        margin 0 10rpx 10rpx 0
                        font-size 14rpx
                        text-align center
                        padding 6rpx 0
                        &:last-child
                            margin-right 0
                        &.active
                            border 1px solid #E60000
                            color #E60000
                            background #fff
                            position relative
                            &:after
                                position absolute
                                content ''
                                bottom 0
                                right -1px
                                width 20rpx
                                height 20rpx
                                background url(./../../../assets/images/contractInfo/pick.png) no-repeat
                                background-size 100% 100%
            .bottom
                height 40rpx
                display flex
                font-size 18rpx
                text-align center
                line-height 40rpx
                .sure-btn
                    flex 1
                    background #E60000
                    height 100%
                    border 1px solid #E60000
                    color #fff
                .reset-btn
                    flex 1
                    height 100%
                    border 1px solid #E60000
                    color #E60000
</style>
